import React from "react";

import cx from "classnames";

import styles from "./buttonLoader.module.scss";

interface ButtonLoaderProps {
  active: boolean;
  style?: React.CSSProperties;
}

const ButtonLoader: React.FC<ButtonLoaderProps> = ({ active, style }) => (
  <span
    className={cx(styles.loader, { [styles.blackLoader]: active })}
    style={style}
  ></span>
);

export default ButtonLoader;
